import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { CalcType } from '../../../lookups/CalcType';
import * as AccountAllocationActions from './account-allocation.actions';
import { AccountAllocation } from './account-allocation.model';

export const accountAllocationsFeatureKey = 'accountAllocations';

export interface State extends EntityState<AccountAllocation> {
    // additional entities state properties
    expenseTypes: CalcType[];
}

export const adapter: EntityAdapter<AccountAllocation> =
    createEntityAdapter<AccountAllocation>({
        selectId: (model: AccountAllocation) => model.Accountlistid
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    expenseTypes: []
});

const accountAllocationReducer = createReducer(
    initialState,
    on(AccountAllocationActions.addAccountAllocation, (state, action) =>
        adapter.addOne(action.accountAllocation, state)
    ),
    on(AccountAllocationActions.upsertAccountAllocation, (state, action) =>
        adapter.upsertOne(action.accountAllocation, state)
    ),
    on(AccountAllocationActions.addAccountAllocations, (state, action) =>
        adapter.addMany(action.accountAllocations, state)
    ),
    on(AccountAllocationActions.upsertAccountAllocations, (state, action) =>
        adapter.upsertMany(action.accountAllocations, state)
    ),
    on(AccountAllocationActions.updateAccountAllocation, (state, action) =>
        adapter.updateOne(action.accountAllocation, state)
    ),
    on(AccountAllocationActions.updateAccountAllocations, (state, action) =>
        adapter.updateMany(action.accountAllocations, state)
    ),
    on(AccountAllocationActions.deleteAccountAllocation, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(AccountAllocationActions.deleteAccountAllocations, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(AccountAllocationActions.loadAccountAllocations, (state, action) =>
        adapter.setAll(action.accountAllocations, state)
    ),
    on(AccountAllocationActions.clearAccountAllocations, state =>
        adapter.removeAll(state)
    ),
    on(AccountAllocationActions.loadExpenseTypes, (state, action) => ({
        ...state,
        expenseTypes: action.expenseTypes
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return accountAllocationReducer(state, action);
}
